import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import {
   companyJobfeedForPartnerAutoCompleteInput$,
   companyJobfeedForPartnerAutoCompleteObservable$,
} from 'app/employer/redux/autosuggest/autoCompleteService';

const CompanyJobfeedForPartnerAutoSuggest = renderAutoSuggestWithOptions(
   companyJobfeedForPartnerAutoCompleteObservable$,
   companyJobfeedForPartnerAutoCompleteInput$,
);

CompanyJobfeedForPartnerAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Company...',
};

export default CompanyJobfeedForPartnerAutoSuggest;
